import React, { useEffect } from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'

const AgendaItems = styled.div`
  position: relative;

  & .ktn-gatherings li {
    display: flex;
    flex-wrap: wrap;

    .ktn-date,
    .ktn-time {
      font-family: ${(props) => props.theme.font.family.main};
      font-size: ${(props) => props.theme.font.size.sm};
      font-weight: bold;
    }
  }
`
const Item = styled(Link)`
  display: block;
  position: relative;
`

const Agenda = ({ className }) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://www.kerktijden.nl/widget/kerktijdenV2-min.js'
    script.type = 'text/javascript'
    script.id = 'kerktijden-widget-gem-503'
    script.setAttribute('data-weken', '3')
    document.getElementById('kerktijden-container')?.appendChild(script)

    return () => {
      script.remove()
    }
  }, [])

  return (
    <AgendaItems className="px-2 px-lg-5 mx-lg-3">
      {/* Het script plaatst zelf een div in dit container-element */}
      <div id="kerktijden-container"></div>
    </AgendaItems>
  )
}

export default Agenda
